module.exports = __webpack_public_path__ + "static/media/white-tick.befef2b0.svg";